
import API from '../../services/client'

export default async (session_uuid)=>{
        let session = await API.CatalogueManager.sessions.findOne(session_uuid)
        session.images = await API.CatalogueImage.images.findMany({ session_uuid: session_uuid })
        return session
}